import React, { useState } from 'react';
import SubcontractorEmployeeForm from './SubcontractorEmployeeForm';
import { createSubcontractorEmployee } from '../api';
import { message } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';

const SubcontractorEmployeeAdd = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { subcontractorId } = useParams();

  const handleSubmit = async (values) => {
    setLoading(true);
    const formData = new FormData();
    formData.append('subcontractor_id', subcontractorId);
    Object.entries(values).forEach(([key, value]) => {
      if (key === 'documents') return;
      if (key === 'profile_image') {
        if (value && value[0] && value[0].originFileObj) {
          formData.append('profile_image', value[0].originFileObj);
        }
        return;
      }
      if (value !== undefined && value !== null && value !== '') {
        formData.append(key, value);
      }
    });

    if (values.documents) {
      values.documents.forEach((doc, idx) => {
        formData.append(`documents[${idx}][document_type]`, doc.document_type || '');
        formData.append(`documents[${idx}][issue_date]`, doc.issue_date || '');
        formData.append(`documents[${idx}][expiry_date]`, doc.expiry_date || '');
        if (doc.document_file && doc.document_file[0]) {
          formData.append(`documents[${idx}][document_file]`, doc.document_file[0].originFileObj);
        }
      });
    }

    const res = await createSubcontractorEmployee(formData);
    setLoading(false);
    if (res.success) {
      message.success('Employee created');
      navigate(`/subcontractors`);
    } else {
      message.error(res.message || 'Failed to create employee');
    }
  };

  return (
    <SubcontractorEmployeeForm
      mode="add"
      onSubmit={handleSubmit}
      loading={loading}
      onCancel={() => navigate(`/subcontractors`)}
    />
  );
};

export default SubcontractorEmployeeAdd; 